import styled, { css, createGlobalStyle } from 'styled-components'
import { color } from 'ui/themes/utils'

export const HostStyles = createGlobalStyle`
  :host {
    --variation-select-border: 1px solid var(--color-border, ${color('Misc/Divider')});
    --variation-select-error-border: 1px solid #C1000F;
    --variation-select-error-color: #C1000F;

    --variation-select-color: var(--color-typo, ${color('text')});
    --variation-select-background-color: var(--color-white, ${color('white')});
    --variation-select-error-background-color: #FFEDEF;
    --variation-select-font-size: 13px;
    --variation-select-font-family: var(--font-body, sans-serif);

    --variation-select-padding: 0 30px 0 10px;

    --variation-select-control-height: 38px;

    --variation-select-border-radius: 6px;
  }
`

const Wrapper = styled.div`
  position: relative;

  svg {
    position: absolute;

    top: 50%;
    right: 10px;
    transform: translateY(-50%);

    width: 14px;
    height: 14px;

    pointer-events: none;
  }
`

const Select = styled.select`
  border: var(--variation-select-border);

  background-color: var(--variation-select-background-color);
  color: var(--variation-select-color);

  font-family: var(--variation-select-font-family);
  font-size: var(--variation-select-font-size);

  padding: var(--variation-select-padding);

  width: 100%;
  height: var(--variation-select-control-height);

  border-radius: var(--variation-select-border-radius);

  appearance: none;

  option {
    color: var(--variation-select-color);
  }

  option:disabled {
    color: ${color('Misc/Divider')};
  }

  /* Fallback for when placeholder is selected */
  &:invalid {
    color: ${color('Misc/Divider')};
  }
  
  ${({ error }) =>
    error && css`
      background-color: var(--variation-select-error-background-color);
      border: var(--variation-select-error-border);
      margin-bottom: 8px;

      /* Fallback for when placeholder is selected */
      &:invalid {
        color: var(--variation-select-error-color);
      }
    `}
`

const Error = styled.div`
  color: #C1000F;
  font-size: 14px;
  line-height: 20px;
`

Wrapper.Select = Select
Wrapper.Error = Error

export default Wrapper
